export const HomePageExplore = [
    {
        tag: 'Free',
        courses : [
            {
                heading : "Learn HTML",
                description : "This course covers the basic concepts of HTML including creating and structuring web pages, adding text, links, images, and more.",
                level : 'Beginner',
                lessionNumber : 4
            },
            {
                heading : "Learn CSS",
                description : "This course explores advanced topics in HTML5 and CSS3, including animations, transitions, and layout techniques",
                level : 'Intermidiate',
                lessionNumber : 5
            },
            {
                heading : "Responsive Web design",
                description : "This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes",
                level : 'Advanced',
                lessionNumber : 9
            },
        ]
    },
    {
        tag: 'New to coding',
        courses : [
            {
                heading : "HTML",
                description : "This course covers the basic concepts of HTML including creating and structuring web pages, adding text, links, images, and more.",
                level : 'Beginner',
                lessionNumber : 5
            },
            {
                heading : "CSS",
                description : "This course explores advanced topics in HTML5 and CSS3, including animations, transitions, and layout techniques",
                level : 'Intermidiate',
                lessionNumber : 3
            },
            {
                heading : "Responsive ",
                description : "This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes",
                level : 'Advanced',
                lessionNumber : 2
            },
        ]
    },
    {
        tag: 'Most popular',
        courses : [
            {
                heading : "Java",
                description : "This course covers the basic concepts of Java including creating and structuring different projects, some data structure part",
                level : 'Advanced',
                lessionNumber : 8
            },
            {
                heading : "Python",
                description : "This course explores advanced topics in python and and its framework, including and data scient basic  knowledge",
                level : 'Intermidiate',
                lessionNumber : 4
            },
            {
                heading : "SCSS",
                description : "This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes",
                level : 'Advanced',
                lessionNumber : 6
            },
        ]
    },
    {
        tag: 'Skills paths',
        courses : [
            {
                heading : "Flask",
                description : "This course covers the basic concepts of Flask including creating and structuring web pages, adding text, links, images, and more.",
                level : 'Beginner',
                lessionNumber : 4
            },
            {
                heading : "Django",
                description : "This course explores advanced topics in Django and CSS3, including animations, transitions, and layout techniques",
                level : 'Intermidiate',
                lessionNumber : 9
            },
            {
                heading : "Fast API",
                description : "This course teaches  Fast API and responsive web design techniques, allowing web pages to adapt to different devices and screen sizes",
                level : 'Beginner',
                lessionNumber : 3
            },
        ]
    },
    {
        tag: 'Career paths',
        courses : [
            {
                heading : "Next.js",
                description : "This course covers the basic concepts of Next.js including creating and structuring web pages, adding text, links, images, and more.",
                level : 'Advanced',
                lessionNumber : 6
            },
            {
                heading : "Nuxt.js",
                description : "This course explores advanced topics in Nuxt.js and CSS3, including animations, transitions, and layout techniques",
                level : 'Beginner',
                lessionNumber : 5
            },
            {
                heading : "Sanity",
                description : "This course teaches Sanity and its basic uses in different fields pages to adapt to different devices and screen sizes",
                level : 'Intermidiate',
                lessionNumber : 4
            },
        ]
    },
]